// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SeletorIdiomas_wrapper__jCAxY","moeda":"SeletorIdiomas_moeda__ON2vf"};